
import { useState, useMemo } from "react";
import { ReagentRequest } from "@/types/reagentRequest.types";

interface UseReagentRequestFiltersProps {
  requests: ReagentRequest[];
}

export const useReagentRequestFilters = ({ requests }: UseReagentRequestFiltersProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all-categories");
  const [selectedLocation, setSelectedLocation] = useState("all-locations");
  const [showFilters, setShowFilters] = useState(true);

  const filteredRequests = useMemo(() => {
    return requests.filter(request => {
      // Filter by search term
      const searchMatch = !searchTerm || 
        request.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (request.catalogue_number && request.catalogue_number.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (request.description && request.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (request.profiles?.display_username && request.profiles.display_username.toLowerCase().includes(searchTerm.toLowerCase()));
      
      // Filter by category
      const categoryMatch = selectedCategory === "all-categories" || request.category_id === selectedCategory;
      
      // Filter by location (university)
      const locationMatch = selectedLocation === "all-locations" ||
        (request.profiles?.university && request.profiles.university === selectedLocation);
      
      return searchMatch && categoryMatch && locationMatch;
    });
  }, [requests, searchTerm, selectedCategory, selectedLocation]);

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCategory("all-categories");
    setSelectedLocation("all-locations");
  };

  return {
    searchTerm,
    setSearchTerm,
    selectedCategory,
    setSelectedCategory,
    selectedLocation,
    setSelectedLocation,
    showFilters,
    setShowFilters,
    filteredRequests,
    resetFilters
  };
};
